import { useState, useEffect, Fragment } from "react";
import { Box, Skeleton, Avatar, Typography, Container, useTheme } from "@mui/material";
import CardsScrollableContainer from "../../components/CardsScrollableContainer";
import CardButton from "../../components/CardButton";
import { RequestsToken, homeToken } from "../../utils/constant";
import { useTranslation } from "react-i18next";
import RequestsDialog from "../../components/Dialog/RequestsDialog";
import { useDispatch, useSelector } from "react-redux";
import { dialogActions } from "../../store/reducers/dialog";
import { useGetRequests, useDeleteRequests } from "../../utils/queries";
import {
  authHeaders,
  getSessionFromStorage,
} from "../../utils/session";
import {
  connectionsApiUrl,
  protocol,
  hostname
} from "../../utils/config";
import CircularLoader from "../../components/CircularLoader";
import ScrollContainerWrapper from "../../components/ScrollContainerWrapper";



const SentRequestsSkelton = () => (
  <>
    {[...Array(12)].map((_, i) => {
      return (
        <Skeleton
          sx={{ width: "35.6rem", height: "15.8rem" }}
          variant="rectangular"
          key={i}
        />
      );
    })}
  </>
);

const Card = ({
  profileImage,
  name,
  profession,
  secondaryCategory,
  requiredSpeciality,
  chapterName,
  connectionUser
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "35.6rem",
        height: "15.8rem",
        backgroundColor: "#F2F2F2",
        display: "flex",
        flexDirection: "column",
        padding: "2.5rem 2.3rem",
        rowGap: "0.9rem",
        borderRadius: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box
          sx={{ width: "7.8rem", display: "flex", justifyContent: "center" }}
        >
          <Avatar
            alt={name}
            src={profileImage?`${protocol}${hostname}:443//core-api/public/image/${profileImage}`:`${name}`}
            sx={{ width: "6.5rem", height: "6.5rem" }}
          />
        </Box>

        <Box sx={{ width: "21rem", display: "flex", flexDirection: "column" }}>
          <Typography
            title={`${name}`}
            sx={{
              fontSize: "2rem",
              color: "#cf2030",
              textWrap: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              cursor: "default",
              whiteSpace:"nowrap"
            }}
          >
            {`${name}`}
          </Typography>
          <Typography
            title={`${profession} | ${secondaryCategory} | ${requiredSpeciality}`}
            sx={{
              fontSize: "1.4rem",
              color: "#676767",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              lineHeight: "1.67rem",
              cursor: "default",
              textWrap: "wrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              WebkitLineClamp: "2",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
            }}
          >
            {[profession, secondaryCategory, requiredSpeciality]
              .filter(Boolean)  
              .join(" | ") || "\u00A0"}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          columnGap: "2rem",
          width: "100%",
        }}
      >
        <Box>
          <CardButton
            btntype={"outlined"}
            value={t(homeToken.Delete)}
            onClickHandler={() => {
              dispatch(dialogActions.setDialogType("deleterequest"));
              dispatch(dialogActions.setRequestId(connectionUser));
              
            }}
          />
        </Box>

        <Box sx={{ width: "21rem" }}>
          <Typography
            sx={{
              fontSize: "1.4rem",
              color: "#cf2030",
              textAlign: theme.direction === "rtl" ? "right" : "left",
              lineHeight: "1.7rem",
              cursor: "default",
            }}
          >
            {`${chapterName?chapterName:" "}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const SentRequests = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dialogType = useSelector((state) => state.dialog.dialogType);
  const deleteId = useSelector((state) => state.dialog.requestId);
  const getSentRequests = useGetRequests();
  const deleteRequest = useDeleteRequests();
  const [sentRequestsData, setSentRequestsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMakeCall, setIsMakeCall] = useState(false);

  const deleteRequestHandler = () => {
    setIsLoading(true);
    setIsMakeCall(false);
    dispatch(dialogActions.setIsDialogEnabled(false));
    dispatch(dialogActions.setDialogType(''));
    dispatch(dialogActions.setDataObj({}));
    dispatch(dialogActions.setRequestId(0));
    if(deleteId!==0){
    deleteRequest.mutate(
      {
        url: `${connectionsApiUrl}delete/request/${deleteId}`
      },
      {
        mutationKey: "deleteSentRequest",
        onSuccess: (success) => {
          if (success.status === 200) {
           setIsLoading(false);
           setIsMakeCall(true);
          }
        },
        onError: (error) => {
          console.log(" request delete failed ", error);
          alert(t(homeToken.GenericError));
        },
      }

    )
  }
  else{
    alert("Invalid delete id");
  }

    };

    useEffect(()=>{
      setIsMakeCall(true);
    },[])

  useEffect(() => {
    if(isMakeCall){
    getSentRequests.mutate(
      {
        url: `${connectionsApiUrl}sent-requests`,
      },
      {
        mutationKey: "sentRequestsData",
        onSuccess: (success) => {
          if (success.status === 200) {
            setSentRequestsData(success.data.content);
          }
        },
        onError: (error) => {
          console.log(" api call error data is ", error);
          alert(t(homeToken.GenericError));
        },
        cacheTime:0
      }
    );
   }
  }, [isMakeCall]);

  return (
    <ScrollContainerWrapper>
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}>
      <CardsScrollableContainer marginTop={"true"} calcHeight="92vh">
        {getSentRequests.isLoading ? (
          <SentRequestsSkelton />
        ) : getSentRequests.isSuccess && sentRequestsData.length >= 1 ? (
          <>
            {sentRequestsData.map((req) => (
              <Card
                key={req.connectionUser}
                profileImage={req.profileImage}
                name={req.name}
                profession={req.profession}
                secondaryCategory={req.secondaryCategory}
                requiredSpeciality ={req.requiredSpeciality}
                chapterName={req.chapterName}
                connectionUser={req.connectionUser}
              />
            ))}
          </>
        ) : (
          <Typography
          sx={{
            width:"100%",
            color: "#cf2030",
            textAlign: "center",
            fontWeight:"700",
            animation: "fadeanimation 2s infinite",
            gridColumn:"1/-1",
          }}
          >{t(homeToken.DataNotFound)}</Typography>
        )}
      </CardsScrollableContainer>
      {dialogType === "deleterequest" && (
        <Container maxWidth="false" disableGutters>
          <RequestsDialog
            dialogTitle={t(RequestsToken.DeleteRequestDialogTitle)}
            dialogContent={t(RequestsToken.DeleteRequestDialogMessage)}
            leftBtnVal={t(homeToken.Yes)}
            rightBtnVal={t(homeToken.No)}
            leftbuttonHandler={deleteRequestHandler}
          />
        </Container>
      )}
      {isLoading&&<CircularLoader/>}
      </Box>
      </ScrollContainerWrapper>
  );
};

export default SentRequests;
